import { useCallback, useState } from 'react';
import { GridColumnResizeParams } from '@rossum/ui/x-data-grid-pro';
import { SimpleColumnsLocation } from '../../document-list-base/types';

export type SimpleColumnWidths = Record<string, number>;

export const useSimpleColumnWidths = (location: SimpleColumnsLocation) => {
  const [columnWidths, setColumnWidths] = useState<SimpleColumnWidths>({});

  const onColumnWidthChange = useCallback(
    ({ colDef, width }: GridColumnResizeParams) => {
      setColumnWidths(previousWidths => ({
        ...previousWidths,
        [colDef.field]: width,
      }));
    },
    [location]
  );

  return { columnWidths, onColumnWidthChange };
};
